module.exports = __webpack_public_path__ + "static/media/icono_telefono_formulario.15a40d89.svg";